(
    function (skyward, $)
    {
        "use strict";

        skyward.performanceTesting = skyward.performanceTesting || {};

        var networkSpeedTestOptions =
        {
            testDuration: 60000,
            maxTestRuns: 500,
            maxTimeToWaitForAjaxToEnd: 30000,
            progressUpdateInterval: 1000
        };

        // Errors don't decrement $.active. This variable keeps track of the number of
        // AJAX requests that error out, so we can tell if any are currently running.
        var errors = 0;
        
        var init = function ()
        {
            var button = $("#bandwidthPerformance");
            if (!button.get(0))
            {
                return;
            }

            $(document).ajaxError(function () { errors++; });

            button.one("click", skyward.performanceTesting.testNetworkSpeed);
        };

        skyward.performanceTesting.testNetworkSpeed = function (options)
        {
            var button = $(this);
            var progressBar = $("#bandwidthPerformanceProgress");
            var progressLabel = $("#bandwidthPerformanceProgressLabel");
            var testResultLabel = $("#bandwidthPerformanceResult");
            var bandwidthPerformanceTest = createBandwidthPerformanceTest();

            skyward.controls.disable(button);
            progressBar.removeAttr("value");
            progressLabel.html("Waiting...");
            testResultLabel.val("N/A");

            bandwidthPerformanceTest.testNetworkSpeed(options).progress(function (percentComplete)
            {
                progressBar.attr("value", percentComplete);
                progressLabel.html(percentComplete + "%");

            }).done(function (result)
            {
                testResultLabel.val(result + " MB/sec");
                button.one("click", skyward.performanceTesting.testNetworkSpeed);
                skyward.controls.enable(button);
            });
        };

        var createBandwidthPerformanceTest = function ()
        {
            var bandwidthPerformanceTest = {};

            bandwidthPerformanceTest.testNetworkSpeed = function (options)
            {
                var settings = $.extend({}, networkSpeedTestOptions, options);
                return performTests(settings);
            };
            
            function performTests(settings)
            {
                var deferred = $.Deferred();
                var finishTest = function ()
                {
                    deferred.notify(100);
                    deferred.resolve(testResults.getNetworkSpeed());
                };
                
                $.when(allAjaxRequestsComplete(settings.maxTimeToWaitForAjaxToEnd)).then(function ()
                {
                    var timeUp = false;
                    
                    clearResourceTimings();
                    
                    // Set up maximum time for tests to run
                    var testProgress = 0;
                    $.wait(settings.testDuration, settings.progressUpdateInterval).progress(function ()
                    {
                        testProgress += settings.progressUpdateInterval;
                        deferred.notify(((testProgress / settings.testDuration) * 100).toFixed(0));
                    }).done(function ()
                    {
                        timeUp = true;
                        finishTest();
                    });

                    // Chain the tests to run one after another
                    chainFunctions(performTestRun, function (iteration, fileSize, duration)
                    {
                        if (timeUp)
                        {
                            return false;
                        }

                        testResults.addTestRun(fileSize, duration);

                        if (iteration + 1 >= settings.maxTestRuns)
                        {
                            finishTest();
                            return false;
                        }

                        if (iteration % 100 == 0)
                        {
                            // By default the buffer should hold at least 150 entries,
                            // but clear more often to be safe
                            clearResourceTimings();
                        }

                        return true;
                    });
                });

                return deferred.promise();
            };

            function chainFunctions(functionToCall, functionToCallHandler)
            {
                (function step(iteration)
                {
                    functionToCall().then(function ()
                    {
                        Array.prototype.unshift.call(arguments, iteration);
                        if (functionToCallHandler.apply(this, arguments))
                        {
                            step(iteration + 1);
                        }
                    });
                })(0);
            }

            function performTestRun()
            {
                var deferred = $.Deferred();
                var stopwatch;
                var TEST_FILE_SIZE = 15492421;

                $.ajax(
                {
                    url: getImageSource(),
                    type: "get",
                    cache: false,
                    beforeSend: function ()
                    {
                        stopwatch = skyward.time.stopwatch();
                    },
                    success: function ()
                    {
                        var duration = stopwatch.duration();

                        // Use resource timing for browsers that support it, since it's more accurate
                        if (window.performance && window.performance.getEntriesByName)
                        {
                            var result = window.performance.getEntriesByName(window.location.origin + this.url)[0];
                            if (result)
                            {
                                duration = result.responseEnd - result.responseStart;
                            }
                        }

                        deferred.resolve(TEST_FILE_SIZE, duration);
                    }
                });

                return deferred.promise();
            };

            function clearResourceTimings()
            {
                // Periodically clear the cache since it'll stop filling once it hits the max.
                // If we ever start using resource timing elsewhere, we'll probably need
                // to listen for the onresourcetimingbufferfull event and handle things appropriately.

                if (window.performance && window.performance.clearResourceTimings)
                {
                    window.performance.clearResourceTimings();
                }
                else if (window.performance && window.performance.webkitClearResourceTimings)
                {
                    // Handle Webkit prefixing
                    window.performance.webkitClearResourceTimings();
                }
            };
            
            function allAjaxRequestsComplete(maxWaitTime)
            {
                var deferred = $.Deferred();
                var getConcurrentAjaxRequestCount = function ()
                {
                    // $.active is changed to $.ajax.active in future versions of jQuery
                    return $.active - errors;
                };

                if (getConcurrentAjaxRequestCount() === 0)
                {
                    return deferred.resolve().promise();
                }

                var ajaxCompleteHandler = function ()
                {
                    if (getConcurrentAjaxRequestCount() - 1 <= 0)
                    {
                        deferred.resolve();
                    }
                };

                deferred.done(function ()
                {
                    $(document).off("ajaxComplete", ajaxCompleteHandler);
                });

                $(document).on("ajaxComplete", ajaxCompleteHandler);
                $.wait(maxWaitTime).then(deferred.resolve);

                return deferred.promise();
            };

            function getImageSource()
            {
                return skyward.global.virtualDir + "content/15meg.png";
            }

            var testResults = (function ()
            {
                var testResults = {};
                var totalFileSize = 0;
                var totalDuration = 0;
                var count = 0;
                var BYTES_IN_MEGABYTE = 1048576;
                var SECONDS_IN_MILLISECOND = 1000;

                testResults.addTestRun = function (fileSize, duration)
                {
                    totalFileSize += parseFloat(fileSize);
                    totalDuration += parseFloat(duration);
                    count++;
                };

                testResults.getNetworkSpeed = function ()
                {
                    if (totalFileSize == 0 || totalDuration == 0)
                    {
                        return -1;
                    }

                    var megabytes = totalFileSize / BYTES_IN_MEGABYTE;
                    var seconds = totalDuration / SECONDS_IN_MILLISECOND;
                    var speed = (megabytes / seconds).toFixed(2);

                    return speed;
                };

                return testResults;
            })();

            return bandwidthPerformanceTest;
        };
        
        // Bootstrap
        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);